import { render } from "./wage-evaluate-referencepositions.vue?vue&type=template&id=634f4a21"
import script from "./wage-evaluate-referencepositions.vue?vue&type=script&lang=js"
export * from "./wage-evaluate-referencepositions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/wagesetting/wage-evaluate-referencepositions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "634f4a21"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('634f4a21', __exports__)) {
    api.reload('634f4a21', __exports__)
  }
  
  module.hot.accept("./wage-evaluate-referencepositions.vue?vue&type=template&id=634f4a21", () => {
    api.rerender('634f4a21', render)
  })

}


export default __exports__